import { createSelector } from 'reselect'
import FormatUtils from '../../../utils/FormatUtils';

// TODO repasser sur tout le code pour s'assurer que c'est bien le sélecteur qui est utilisé
export const userSelector = state => state.user

export const dateDebutContratSelector = createSelector([
	userSelector
], (user) => {
	if (user && user.dateDebutContrat) {
		return FormatUtils.toLocalDate(user.dateDebutContrat)
	}
	return null
})

const emptyProfile = {}
export const profileSelector = createSelector([
	userSelector
], (user) => {
	const userProfile = user?.profil || emptyProfile
	const {
		santeclair,
		itelis
	} = userProfile
	return {
		...userProfile,
		// RG: Itelis ne peut pas être affiché seul
		sansReseauSoins: !santeclair && !itelis
	}
})

export const profileSelectorKpi = createSelector([
	userSelector,
], (user) => {
	const userProfile = user?.profil || emptyProfile
	return {
		...userProfile
	}
})
